export default __webpack_public_path__ + "src/images/packages/qambathi-mountain-lodge/96283d61a1635fc9c6c0aaa62173906b-5.jpg";